<div *ngIf="branding" class="">
    <div class="mx-auto max-w-CONTENT h-fit">
      <div class="flex-col content-center items-center text-center">
        <div>
          <img class="mx-auto items-center" src="/assets/confetti-illustration.svg" />
        </div>
        <div class="mt-7">
          <span class="block font-medium text-7 text-neutral-700">Thanks {{refereeFirstName}}</span>
          <span class="block text-neutral-700 text-4 pt-4">Your reference for {{applicantName}} has been received and we look forward to reviewing it</span>
          <span class="block text-neutral-500 pt-4 text-4">Feel free to close this browser window</span>
        </div>
      </div>
    </div>
</div>
